import $ from 'jquery';
import objectFitImages from 'object-fit-images';
export function position_adjust() {
  // topページのファーストビューがフルスクリーンでなくなったので、scrollマークの位置を微調整する。
  if ($('.crf-p-top').length >= 1) {
    const resize_func = () => {
      const heroImg_height = $('.crf-hero_images').height() + 80;
      const window_height = window.innerHeight;
      if (window_height <= heroImg_height) {
        $('#js-positionAdjust__scroll').addClass('is-position__adjust');
      } else {
        $('#js-positionAdjust__scroll').removeClass('is-position__adjust');
      }
    };
    resize_func();

    let timer_riseze = null;
    $(window).on('resize', function () {
      if (timer_riseze !== null) {
        clearTimeout(timer_riseze);
      }
      timer_riseze = setTimeout(function () {
        resize_func();
      }, 200);
    });
    objectFitImages();
  }
}
